import React, { useState, useEffect } from 'react';

const RandomFoodRecommender = () => {
  const [recommendedFood, setRecommendedFood] = useState('');

  // 음식 데이터
  const foods = {
    korean: [
      '김치찌개', '된장찌개', '비빔밥', '불고기', '삼겹살', 
      '떡볶이', '김밥', '순두부찌개', '냉면', '칼국수',
      '제육볶음', '돈까스', '감자탕', '부대찌개', '닭갈비'
    ],
    chinese: [
      '짜장면', '짬뽕', '탕수육', '마파두부', '군만두',
      '양장피', '깐풍기', '볶음밥', '우동', '쟁반짜장'
    ],
    japanese: [
      '초밥', '라멘', '우동', '돈부리', '카레',
      '오니기리', '덮밥', '텐동', '소바', '규동'
    ],
    western: [
      '파스타', '피자', '햄버거', '스테이크', '샐러드',
      '리조또', '오믈렛', '샌드위치', '타코', '또띠아'
    ],
    etc: [
      '쌀국수', '팟타이', '카레', '케밥', '마라탕',
      '월남쌈', '나시고랭', '똠양꿍', '포케', '부리또'
    ]
  };

  // 랜덤 음식 선택 함수
  const getRandomFood = () => {
    // 모든 카테고리의 음식을 하나의 배열로 합침
    const allFoods = Object.values(foods).flat();
    // 랜덤 인덱스 생성
    const randomIndex = Math.floor(Math.random() * allFoods.length);
    return allFoods[randomIndex];
  };

  // 카테고리별 랜덤 음식 선택 함수
  const getRandomFoodByCategory = (category) => {
    if (!foods[category]) return getRandomFood();
    const categoryFoods = foods[category];
    const randomIndex = Math.floor(Math.random() * categoryFoods.length);
    return categoryFoods[randomIndex];
  };

  // 컴포넌트 마운트 시 초기 추천
  useEffect(() => {
    setRecommendedFood(getRandomFood());
  }, []);

  // 새로운 추천 요청 시
  const getNewRecommendation = () => {
    setRecommendedFood(getRandomFood());
  };

  // 특정 카테고리 추천 요청 시
  const getNewRecommendationByCategory = (category) => {
    setRecommendedFood(getRandomFoodByCategory(category));
  };

  return recommendedFood;
};

export default RandomFoodRecommender;